/* Auto-remove the free sample poop bag when a paid poop-bag product is in the cart,
   or when the customer already claimed one (data.blocked, set from the 'sample-claimed'
   Flow tag). Rule data is emitted by snippets/cart-free-sample-checkbox.liquid. */
(function () {
  if (window.__freeSampleRule) return;
  window.__freeSampleRule = true;

  var running = false;

  function ruleData() {
    var tag = document.querySelector('script.free-sample-rule-data');
    if (!tag) return null;
    try {
      return JSON.parse(tag.textContent);
    } catch (e) {
      return null;
    }
  }

  function syncCheckboxVisibility(cart, data) {
    var sampleInCart = false;
    var hasPoopBag = false;
    cart.items.forEach(function (item) {
      if (item.variant_id === data.freeSampleVariantId) sampleInCart = true;
      else if (data.poopBagVariantIds.indexOf(item.variant_id) !== -1) hasPoopBag = true;
    });
    var hide = cart.item_count === 0 || sampleInCart || hasPoopBag;
    document.querySelectorAll('.cfs-wrap').forEach(function (w) {
      w.classList.toggle('cfs-hidden', hide);
    });
  }

  function enforce() {
    var data = ruleData();
    if (!data || running) return;
    running = true;
    fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sample = null;
        var hasPoopBag = false;
        cart.items.forEach(function (item) {
          if (item.variant_id === data.freeSampleVariantId) sample = item;
          else if (data.poopBagVariantIds.indexOf(item.variant_id) !== -1) hasPoopBag = true;
        });
        if (!sample || (!hasPoopBag && !data.blocked)) {
          running = false;
          syncCheckboxVisibility(cart, data);
          return;
        }
        var body = JSON.stringify({ id: sample.key, quantity: 0 });
        return fetch(window.routes && routes.cart_change_url ? routes.cart_change_url : '/cart/change', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: body
        }).then(function () {
          running = false;
          var cartEl = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
          if (cartEl && typeof cartEl.onCartUpdate === 'function') cartEl.onCartUpdate();
        });
      })
      .catch(function () { running = false; });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { enforce(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }
})();
